import { render, staticRenderFns } from "./imgCard.vue?vue&type=template&id=3bf467f8&scoped=true&"
import script from "./imgCard.vue?vue&type=script&lang=js&"
export * from "./imgCard.vue?vue&type=script&lang=js&"
import style0 from "./imgCard.vue?vue&type=style&index=0&id=3bf467f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf467f8",
  null
  
)

export default component.exports